module.exports = __webpack_public_path__ + "img/taskbtn.78e1c447.png";